import request from '@/utils/request';

//模板列表数据
export function getQueryMailTemplate(values) {
  return request('/mail/queryMailTemplatePage', {
    method: 'POST',
    data: values,
  });
}

//删除模板列表数据
export function deleteMailTemplate(values) {
  return request('/mail/deleteMailTemplate', {
    method: 'POST',
    data: values,
  });
}
